export function isAdmin() {
  return window.location.search.includes("admin")
}
